import { RedocStandalone } from 'redoc';


function getSchemaVersion(acceptedVersions) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  if (params.version && acceptedVersions.includes(params.version)) {
    return `schema-${params.version}.yaml`
  }
  return 'schema.yaml';
}


function App() {
  const schemaVersionedName = getSchemaVersion(['1.0.0', '1.1.0', '1.2.0']);
  const schemaURL = `${process.env.REACT_APP_SCHEMA_URL}/${schemaVersionedName}`;

  return (
    <div className="App">
      <RedocStandalone
          specUrl={schemaURL}
          options={{
              hideDownloadButton: true,
              nativeScrollbars: true,
              disableSearch: true,
              hideLoading: true,
              theme: {
                  rightPanel: {
                      backgroundColor: "#1A222E"
                  },
                  colors: {
                      primary: { main: '#1A222E' }
                  }
              }
          }}
      />
    </div>
  );
}

export default App;
